import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IMailStatuses, MailStatusesRequest, IMailStatusForStatistics, MailStatusesPage, MailStatusesPagedData, IMailStatus } from './mailstatuses-model';

@Injectable()
export class MailStatusesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${MailStatusesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/mailstatuses';

    public getMailStatuses(page: MailStatusesPage): Observable<SuccessResponse<MailStatusesPagedData<IMailStatus>> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<MailStatusesPagedData<IMailStatus>>>(MailStatusesService.URL, page).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getMailStatusesForStatistics(model: MailStatusesRequest): Observable<SuccessResponse<IMailStatusForStatistics> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IMailStatusForStatistics>>(MailStatusesService.URL + '/statistics', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getMailStatusesForExport(model: MailStatusesRequest): Observable<SuccessResponse<IMailStatuses> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IMailStatuses>>(MailStatusesService.URL + '/exports', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
